import styled from 'styled-components';

import { Link } from '@savgroup-front-common/core/atoms/link';
import { fontStyle } from '@savgroup-front-common/core/theme/helpers/fontStyle';

export const $ToastLink = styled(Link)`
  display: block;
  text-decoration: underline;
`;

export const $ToastTime = styled.p`
  color: ${({ theme }) => theme.colors.paragraphTextColor};
  ${fontStyle('xs')};
  margin: 0;

  display: flex;
  justify-content: space-between;
`;
